module.exports = __webpack_public_path__ + "img/6@3x.bc186b24.png";